import { TelecomPhoneLineId, UserId } from "@sp-crm/core";

export interface PlacedBridgeCall {
    phoneLineId: TelecomPhoneLineId;
    callSid: string;
}

interface RememberedBridgeCall extends PlacedBridgeCall {
    userId: UserId;
}

const storageKey = "telecom.bridgeCall";

const isRememberedBridgeCall = (value: unknown): value is RememberedBridgeCall =>
    typeof value === "object" &&
    value !== null &&
    "userId" in value &&
    typeof value.userId === "string" &&
    "phoneLineId" in value &&
    typeof value.phoneLineId === "string" &&
    "callSid" in value &&
    typeof value.callSid === "string";

const storedBridgeCall = (): RememberedBridgeCall | null => {
    try {
        const stored: unknown = JSON.parse(localStorage.getItem(storageKey) ?? "null");
        return isRememberedBridgeCall(stored) ? stored : null;
    } catch {
        return null;
    }
};

export const rememberedBridgeCallFor = (userId: UserId): PlacedBridgeCall | null => {
    const stored = storedBridgeCall();
    return stored?.userId === userId
        ? { phoneLineId: stored.phoneLineId, callSid: stored.callSid }
        : null;
};

export const rememberBridgeCall = (userId: UserId, call: PlacedBridgeCall): void => {
    try {
        localStorage.setItem(storageKey, JSON.stringify({ userId, ...call }));
    } catch {
        return;
    }
};

export const forgetBridgeCall = (callSid: string): void => {
    try {
        if (storedBridgeCall()?.callSid === callSid) {
            localStorage.removeItem(storageKey);
        }
    } catch {
        return;
    }
};
